import { ActionButton, ActionButtonType } from "@octopusdeploy/design-system-components";
import { useTrackEvent } from "@octopusdeploy/portal-analytics";
import { OctoLink } from "@octopusdeploy/utilities";
import type React from "react";
import { useState } from "react";
import CustomDialog from "~/components/Dialog/CustomDialog";
import { CustomExternalLinkDialogLayout, SmallDialogFrame } from "~/components/DialogLayout/Custom";
interface Props {
    label: string;
    serialNumber: string;
}
export function InviteOctoIdUserDialogLink({ label, serialNumber }: Props) {
    const [showDialog, setShowDialog] = useState(false);
    const trackEvent = useTrackEvent();
    const showDialogHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        trackEvent({ eventName: "Invite User Button Clicked" });
        setShowDialog(true);
    };
    const closeDialogHandler = () => {
        setShowDialog(false);
    };
    return (<>
            <CustomDialog open={showDialog} close={closeDialogHandler} render={() => (<CustomExternalLinkDialogLayout title="Invite User" externalLink={OctoLink.Create(`cloud-invite-user?serial=${serialNumber}`)} externalLinkLabel="Control Center" open={showDialog} close={closeDialogHandler} frame={SmallDialogFrame} dispatchAnalytics={() => trackEvent({
                eventName: "Invite User: Go To Control Center Button Clicked",
            })}>
                        <>User invites are managed in Control Center.</>
                    </CustomExternalLinkDialogLayout>)}/>
            <ActionButton onClick={showDialogHandler} label={label} type={ActionButtonType.Primary}/>
        </>);
}
